import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Deine Kurskarte wird sofort nach der Bestellung gutgeschrieben."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Sobald du die Bestellung abgeschlossen hast, erhältst du die Bankverbindung zum Begleichen der Rechnung. ")
], -1)
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "register-input-consent-terms"
}, [
  /*#__PURE__*/_createTextVNode(" Ja, ich habe die "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.buggyfit.de/agb",
    target: "_blank",
    style: {"font-weight":"bold","color":"#cc3366"}
  }, [
    /*#__PURE__*/_createElementVNode("u", null, "AGB")
  ]),
  /*#__PURE__*/_createTextVNode(" gelesen und akzeptiert. ")
], -1)
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "register-input-consent-privacy"
}, [
  /*#__PURE__*/_createTextVNode(" Ja, ich habe die "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.buggyfit.de/datenschutz",
    target: "_blank",
    style: {"font-weight":"bold","color":"#cc3366"}
  }, [
    /*#__PURE__*/_createElementVNode("u", null, "Datenschutzerklärung")
  ]),
  /*#__PURE__*/_createTextVNode(" gelesen und akzeptiert. ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-exclamation-triangle me-1" }, null, -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "fa fa-spin fa-spinner me-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Bestellung abschließen ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldError = _resolveComponent("FieldError")!
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        class: _normalizeClass(["d-none form-check-input", {'is-invalid': _ctx.showErrors && _ctx.errors.consent_terms.length > 0}]),
        id: "register-input-consent-terms",
        "aria-describedby": "register-input-consent-terms-description",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.consent_terms) = $event))
      }, null, 2), [
        [_vModelCheckbox, _ctx.form.consent_terms]
      ]),
      _hoisted_3,
      (_ctx.showErrors)
        ? (_openBlock(), _createBlock(_component_FieldError, {
            key: 0,
            errors: _ctx.errors.consent_terms || []
          }, null, 8, ["errors"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        class: _normalizeClass(["d-none form-check-input", {'is-invalid': _ctx.showErrors && _ctx.errors.consent_privacy.length > 0}]),
        id: "register-input-consent-privacy",
        "aria-describedby": "register-input-consent-privacy-description",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.consent_privacy) = $event))
      }, null, 2), [
        [_vModelCheckbox, _ctx.form.consent_privacy]
      ]),
      _hoisted_5,
      (_ctx.showErrors)
        ? (_openBlock(), _createBlock(_component_FieldError, {
            key: 0,
            errors: _ctx.errors.consent_privacy || []
          }, null, 8, ["errors"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 0,
          type: "danger"
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.errorMessage), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "btn btn-lg btn-primary",
      disabled: _ctx.loading,
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.performOrder && _ctx.performOrder(...args)), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("i", _hoisted_8, null, 512), [
        [_vShow, _ctx.loading]
      ]),
      _hoisted_9
    ], 8, _hoisted_7)
  ], 64))
}